export const BASE_PATH = "prospect.organizationInfo.addressInfo[0].addressDetails[0]";
export const MAX_PO_BOX_LENGTH = 10;
export const UAE = "AE";
